import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
    borderRadius: 0,
    paddingLeft: 24,
    paddingRight: 24,
    height: theme.heightDesktopPageHeader,
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      height: "auto",
      padding: "9px 24px",
      display: "grid",
      gridTemplateColumns: "4fr 3fr 2fr",
      gap: 10
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      padding: 16,
      height: 60,
      display: "flex"
    }
  },
  leftPart: {
    maxWidth: "66%",
    marginRight: "16px",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      maxWidth: "none",
      marginRight: 0
    }
  },
  centralPart: {
    display: "flex",
    justifyContent: "center"
  },
  progress: {
    textAlign: "center"
  },
  currentlyViewing: {
    fontSize: 12,
    color: theme.palette.text.hint,
    lineHeight: "normal"
  },
  name: {
    position: "relative",
    fontSize: 20,
    color: theme.palette.text.primary,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingRight: "2px",
    display: "inline",
    wordBreak: "break-all",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      cursor: "pointer"
    },
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      lineHeight: 1,
      fontSize: 16
    }
  },
  age: {
    textAlign: "right",
    fontSize: 14,
    lineHeight: "normal"
  },
  color: {
    textAlign: "right",
    fontSize: 14,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal"
  },
  horseNameButton: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap"
  },
  arrowIcon: {
    color: "black",
    transform: "rotate(90deg)",
    transition: "transform 0.8s ease",
    fontSize: "16px",
    cursor: "pointer"
  },
  arrowIconReversed: {
    transform: "rotate(270deg)"
  },
  appSearch: {
    width: 380,
    [theme.breakpoints.down("md")]: {
      width: 304,
      maxWidth: 304
    },
    [theme.breakpoints.down("sm")]: {
      width: "initial"
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  ageGender: {
    marginRight: 6
  },
  horseHeaderDetails: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center"
  },
  cbsIcon: {
    width: 32,
    height: "unset"
  }
}));
